namespace TabAurous.Sales {
    export namespace OpenConsignmentOutService {
        export const baseUrl = 'Sales/OpenConsignmentOut';

        export declare function List(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<ApprovalOutItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function PartyList(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<ApprovalOutItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "Sales/OpenConsignmentOut/List",
            PartyList = "Sales/OpenConsignmentOut/PartyList"
        }

        [
            'List', 
            'PartyList'
        ].forEach(x => {
            (<any>OpenConsignmentOutService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
